// ------------------------------
// * model.message.js *
// Defines models for the office messaging system
// ------------------------------

goog.provide('el8.ptdata.model.message');

//goog.require('el8.data.currUser');
goog.require('el8.appservice.notifier');
goog.require('el8.data.referencedUsers');
goog.require('el8.data.staffGroups');
goog.require('el8.model.base');
goog.require('el8.ptdata.patients');
goog.require('el8.service.tz');
goog.require('el8.template.ptdata.model.message');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.base');
goog.require('el8.util.datecompare');


// -------------------
// ** THREAD MEMBER **
// -------------------

(function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        this.parent.populate.call(this, spec);

        // Need to update model to point to ID not to object, but
        // for now, hard-code in spec.user_id or spec.userId
        if (spec.user_id || spec.userId) {
            this.setUser(el8.data.referencedUsers.getById(spec.user_id || spec.userId));
        }
        if (spec.group) {
            this.setGroup(el8.data.staffGroups.create(spec.group));
        } else if (spec.group_id || spec.groupId) {
            this.setGroup(el8.data.staffGroups.getById(spec.group_id || spec.groupId, false, true));
        }
    };

    _class.addProperty('user');
    _class.addProperty('group');
    _class.addStringProperty('status', true);

    _class.prototype.getUserId = function() {
        var user = this.getUser();
        return user ? user.getId() : null;
    };
    _class.prototype.getGroupId = function() {
        var group = this.getGroup();
        return group ? group.getId() : null;
    };

    _class.prototype.getMemberName = function() {
        // Try user name first, then group name
        var user = this.getUser();
        if (user) {
            return user.getFullName();
        }
        var group = this.getGroup();
        if (group) {
            return group.getName();
        }
        return '';
    };
    _class.prototype.isMember = function(user) {
        var group = this.getGroup();
        return group ? group.isUserMember(user.getId()) : false;
    };

    _class.prototype.asMap = function() {
        var result = this.parent.asMap.call(this);
        result.userId = this.getUserId();
        result.groupId = this.getGroupId();
        result.userName = this.getUser() ? this.getUser().getFullName() : null;
        result.groupName = this.getGroup() ? this.getGroup().getName() : null;
        result.status = this.getStatus();
        return result;
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped['name'] = this.getMemberName();
        return mapped;
    };

    el8.ptdata.model.message.threadMember = function(spec) {
        return new _class(spec);
    };

})();

// --------------------
// ** THREAD PATIENT **
// --------------------

(function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);

    _class.addIntProperty('patientId', true);
    _class.prototype.getPatient = function() {
        return el8.ptdata.patients.getById( this.getPatientId() );
    };
    _class.prototype.getPatientFullName = function() { return this.getPatient().getFullName(); };

    _class.prototype.asMap = function() {
        var result = this.parent.asMap.call(this);
        result.patientName = this.getPatient().getFullName();
        return result;
    };

    el8.ptdata.model.message.threadPatient = function(spec) {
        return new _class(spec);
    };

})();


// --------------------
// ** THREAD MESSAGE **
// --------------------

(function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);

    _class.addIntProperty('senderId', true);
    _class.addDateTime('sendDate');
    _class.addStringProperty('body', true);
    _class.addProperty('attachmentUrl', true); // XSS REVISIT -KF
    _class.addIntProperty('toDocId', true);

    _class.prototype.getSender = function() { return el8.data.referencedUsers.getById( this.getSenderId() ); };

    _class.prototype.asMap = function() {
        var result = this.parent.asMap.call(this);
        result.senderName = this.getSender().getFullName();
        result.senderGroup = this.getSender().getGroup();
        result.sendDate = this.getSendDate();
        return result;
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped['senderName'] = this.getSender().getFullName();
        mapped['isPhysician'] = this.getSender().isPhysician();
        return mapped;
    };

    el8.ptdata.model.message.threadMessage = function(spec) {
        return new _class(spec);
    };

})();

// -------------------------
// ** FINALLY, THE THREAD **
// -------------------------

(function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addModelSetProperty('members', el8.ptdata.model.message.threadMember, false, []);
    _class.addModelSetProperty('patients', el8.ptdata.model.message.threadPatient, false, []);
    _class.addModelSetProperty('messages', el8.ptdata.model.message.threadMessage, false, []);
    _class.addModelSetProperty('dataDocuments',
        function(spec) {
            var c = function(spec) { this.populate(spec); };
            c.inheritsFrom(el8_Entity);
            c.addStringProperty('text', true);
            c.addIntProperty('toDocId', true);
            return new c(spec);
        },
        []
    );

    _class.addProperty('hold'); // XSS REVISIT -KF
    _class.addProperty('canUserSign'); // XSS REVISIT -KF
    _class.addBoolean('urgent');

    _class.addDateTime('deliveryDate');

    _class.prototype.getDescription = function() {
        return 'Office Message';
    };

    // ------------------------------
    // Feed support functions
    // ------------------------------
    _class.prototype.getFirstMessage = function() {
        return this.getMessages()[0];
    };

    _class.prototype.getLastMessage = function() {
        var length = this.getMessages().length;
        return this.getMessages()[ length - 1 ];
    };

    _class.prototype.isMessageToSelf = function() {
        var members = this.getMembers();
        for (var i=0; i<members.length; i++) {
            if (members[i].getUserId() !== el8.data.currUser.getId()) {
                return false;
            }
        }
        return true;
    };

    _class.prototype.hasAnyOneElseReplied = function() {
        /* If current user is the only thread member, return true - don't want to trigger error case */
        if (this.isMessageToSelf()) { return true; }
        var messages = this.getMessages();
        for (var i=0; i<messages.length; i++) {
            if (messages[i].getSenderId() !== el8.data.currUser.getId()) {
                return true; // have a message not from curr user
            }
        }
        return false; // all messages are from curr user
    };

    _class.prototype.getCurrMember = function() {
        // We're going to loop through twice, because the user might be a member
        // directly, and as a member of a group. We want to use the most specific.

        // First check to see if user is actual individual member
        for (var i=0; i<this.getMembers().length; i++) {

            if (this.getMembers()[i].getUserId() === el8.data.currUser.getId()) {
                return this.getMembers()[i];
            }
        }

        // If not, then check to see if is member of a group
        for (var i=0; i<this.getMembers().length; i++) {

            if (this.getMembers()[i].isMember(el8.data.currUser)) {
                return this.getMembers()[i];
            }
        }

        return null;
    };


    _class.prototype.isStaffOnly = function() {
        // Returns true if there are no physicians on this thread
        for (var i=0; i<this.getMembers().length; i++) {
            var user = this.getMembers()[i].getUser();
            if (user && user.isPhysician()) {
                return false;
            }
        }
        return true;
    };

    _class.prototype.isAcknowledgeableBy = function(userId) {
        for (var i=0; i<this.getMembers().length; i++) {
            if ((this.getMembers()[i].getUserId() === userId) &&
                    (this.getMembers()[i].getStatus() === 'ReqAct')) {
                return this.isSignedOff();
            }
        }
        return false;
    };

    _class.prototype.isAcknowledgeableByAnyone = function() {
        // True if at least one member of this thread is ReqAct
        // and the thread is signed off.
        for (var i=0; i<this.getMembers().length; i++) {
            if (this.getMembers()[i].getStatus() === 'ReqAct') {
                return this.isSignedOff();
            }
        }
        return false;
    };

    _class.prototype.getNoteSummary = function() {
        return (el8.template.ptdata.model.message.noteSummary(this.asSoyMap())).el8_unescape();
    };

    _class.prototype.getFeedStatus = function() {
        if( this.getHold() !== null ) {
            return "ONHOLD";
        } else if (this.getCurrMember() && (this.getCurrMember().getStatus() === 'ReqAct')) {
            return "NEW";
        } else {
            return "REVIEWED";
        }
    };

    _class.prototype.getDescription = function() {
        var text = "";
        for( var i = 0; i<this.getPatients().length; i++ ) {
            text += ( i === 0 ? "RE: " : ", " ) + this.getPatients()[i].getPatientFullName();
        }
        return text;
    };

    _class.prototype.getNotifyText = function( type ) {
        var locStr = ' in chart.';
        /*if( type === 'SAVE_IN_PROGRESS' ) {
            return 'Sending message...';
        } else*/
        if( type === 'SAVE_COMPLETE' || type === 'MOVED_TO_FEED' ) {
            return 'Message sent and filed' + locStr;
        } else if( type === 'ADD_TO_NOTE' ) {
            return 'Message thread added to current note.';
        } else if( type === 'SIGNOFF_IN_PROGRESS' ) {
            return 'Signing off message thread...';
        } else if( type === 'SIGNOFF_COMPLETE' ) {
            return 'Message thread signed off and filed' + locStr;
        }
    };

    _class.prototype.isAllSameDay = function() {
        // Added flag to override this test
        if (this.alwaysDisplayDate === true) { return false; }

        var messages = this.getMessages();
        for( var i=0; i<messages.length; i++ ) {
            if( !el8.util.datecompare.isSameDay( messages[i].getSendDate(), this.getFirstMessage().getSendDate() ) ) {
                return false;
            }
        }

        if (!el8.util.datecompare.isSameDay(this.getDocumentDate(), this.getFirstMessage().getSendDate())) {
            return false;
        }

        return true;
    };

    _class.prototype.isReviewed = function() { return ( this.getFeedStatus() === 'REVIEWED' ); };

    _class.prototype.isClosed = function() {
        // Check if the is no threadmember requiring action
        for( var i=0; i<this.getMembers().length; i++ ) {
            if( this.getMembers()[i].getStatus() === "ReqAct" ) {
                return false;
            }
        }
        return true;
    };

    _class.prototype.addMember = function( member ) {
        var result = this.getMembers();
        result.push( member );
        this.setMembers( result );
    };

    _class.prototype.addPatient = function( patient ) {
        var result = this.getPatients();
        result.push( patient );
        this.setPatients( result );
    };

    _class.prototype.addMessage = function( message ) {
        var result = this.getMessages();
        result.push( message );
        this.setMessages( result );
    };

    _class.prototype.canUserSign = function ()  {
        if (this._canUserSign != undefined) {
            return this._canUserSign;
        }
        return false;
    }

    _class.prototype.signOff = function(callback) {

        var that = this;
        if (el8.data.currUser.isPhysician()) {
            el8.appservice.notifier.notify(that.getNotifyText( 'SIGNOFF_IN_PROGRESS' ) );
        }

        var result = {
            id: that.getId(),
            senderId: el8.data.currUser.getId()
        };

        $.el8_ajax({
            type: 'POST',
            url: '/postThreadSignOff/',
            data: JSON.stringify(result),
            success: function(data) {
                el8.ptdata.messageThreads.create(data);
                if (el8.data.currUser.isPhysician()) {
                    el8.appservice.notifier.notify(that.getNotifyText( 'SIGNOFF_COMPLETE' ) );
                }
                if (callback) { callback(that, data); }
            }

        });
    };

    _class.prototype.isReqAct = function(user) {
        // Verify that the thread requires the action of the given user
        for (var i=0; i<this.getMembers().length; i++) {
            if ((this.getMembers()[i].getUserId() === user.getId() ||
                 this.getMembers()[i].isMember(user)) &&
                this.getMembers()[i].getStatus() === "ReqAct" &&
                !this.isSignedOff()) {
                return true;
            }
        }
        return false;
    };

    _class.prototype.asSoyMap = function(inChart) {

        var that = this;

        var messages = that.getMessages().map(function(message){
            var mapped = message.asSoyMap();

            $.extend(mapped, {
                docId : inChart
                  ? message.getToDocId()
                  : null,
                // Make sure this doesn't create a circular reference if we expand to other types of documents besides reports
                docSummary: !message.getToDocId()
                  ? ''
                  : (inChart
                      ? el8.ptdata.fetchById(message.getToDocId(), true).getNoteSummary()
                      : 'patient report - open chart to view.'),
                docPlaceholder: (!message.getToDocId() || inChart)
                  ? null
                  : 'patient report - open chart to view.'
            });

            return mapped;
        });

        var mapped = this.parent.asSoyMap.call(this);

        mapped['members'] = that.getMembers().map(el8.model.toSoyMapFn);
        mapped['messages'] = messages;

        mapped['signOffUser'] = that.isSignedOff() ? that.getSignUserName(): '';
        mapped['signUserType'] = that.isSignedOff() ? that.getSignUserType(): '';

        return mapped;
    };

    el8.ptdata.model.message.thread = function(spec) {
        spec.model_class = 'MessageThread';
        return new _class(spec);
    };

})();

